/**
 * Lot Info
 * Handles lot number selection and subheading display on testing info pages
 */

function lotInfo(opts = {}) {
  const config = {
    dom: {
      lotNumber: 'js-lot-number',
      lotSubHeading: 'js-lot-sub-heading',
      subHeading: 'js-sub-heading',
    },
  };

  // Native replacement for _.extend
  const c = Object.assign({}, config, opts);

  // Native replacement for _.getUrlParameter
  const urlParams = new URLSearchParams(window.location.search);
  const lotNumber = urlParams.get('lotNumber');

  const $subHeading = document.querySelector(`.${c.dom.subHeading}`);
  const $lotNumbers = Array.from(document.querySelectorAll(`.${c.dom.lotNumber}`));
  const $lotSubHeadings = Array.from(document.querySelectorAll(`.${c.dom.lotSubHeading}`));

  /**
   * Check if lot exists
   */
  function lotExists() {
    return $lotNumbers.some(($lotNumber) => $lotNumber.innerHTML === `#${lotNumber}`);
  }

  /**
   * Get lot sub heading
   */
  function getLotSubHeading() {
    return $lotSubHeadings.find(($lotSubHeading) => $lotSubHeading.dataset.lotId === lotNumber);
  }

  /**
   * Create sub heading
   */
  function createSubHeading() {
    const $lotSubHeading = getLotSubHeading();
    if (!$lotSubHeading) return '';

    const lotSubHeadingText = $lotSubHeading.innerHTML;
    const lotSubHeadingTextArray = lotSubHeadingText.split(' ');
    let subHeading;

    if (lotSubHeadingTextArray[0] === 'Manuf.') {
      subHeading = `Lot #${lotNumber} - Manufacturing date ${lotSubHeadingTextArray[1]}`;
    } else if (lotSubHeadingTextArray[0] === 'Exp.') {
      subHeading = `Lot #${lotNumber} - Expiration date ${lotSubHeadingTextArray[1]}`;
    } else {
      subHeading = '';
    }

    return subHeading;
  }

  /**
   * Init
   */
  function init() {
    const lotIsValid = lotExists();

    if (lotNumber) {
      if (!lotIsValid) {
        window.location.href = '/pages/404';
        return;
      }

      const subHeadingText = createSubHeading();

      if (subHeadingText && $subHeading) {
        $subHeading.innerHTML = subHeadingText;
      }
    }
  }

  return init();
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', lotInfo);
} else {
  lotInfo();
}
